module.exports = __webpack_public_path__ + "static/faq_shape_2-bb9d010ca36b71de9ab8c12cc392ab2d.svg";